import React from 'react';

const SelectedProductsDropdown = ({
  selectedCount,
  show,
  onToggleShow,
  onCloseDropdown,
  onOpenBulkArrivalDate,
  onOpenBulkClearArrivalDate,
  onOpenBulkAddCategory,
  onOpenBulkRemoveCategory,
  onOpenBulkDiscount,
  onOpenBulkStatus,
  onOpenBulkDiscountCategory,
  onClearSelection,
  bulkClearLoading,
  arrivalSubmenuTimeoutRef,
  categorySubmenuTimeoutRef,
  showArrivalSubmenu,
  setShowArrivalSubmenu,
  showCategorySubmenu,
  setShowCategorySubmenu
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className="dropdown d-inline-block position-relative">
      <button
        type="button"
        className="btn btn-dark btn-sm dropdown-toggle"
        onClick={() => onToggleShow(!show)}
        style={{ fontSize: '0.875rem' }}
      >
        Обрані: {selectedCount}
      </button>
      {show && (
        <>
          <div
            className="position-fixed"
            style={{ inset: 0, zIndex: 1040 }}
            onClick={() => {
              onCloseDropdown();
              setShowArrivalSubmenu(false);
              setShowCategorySubmenu(false);
            }}
            aria-hidden="true"
          />
          <div className="dropdown-menu show position-absolute" style={{ zIndex: 1050 }}>
            <div
              className="position-relative"
              onMouseEnter={() => {
                if (arrivalSubmenuTimeoutRef.current) clearTimeout(arrivalSubmenuTimeoutRef.current);
                setShowArrivalSubmenu(true);
              }}
              onMouseLeave={() => {
                arrivalSubmenuTimeoutRef.current = setTimeout(() => setShowArrivalSubmenu(false), 150);
              }}
            >
              <div className="dropdown-item d-flex align-items-center justify-content-between" style={{ cursor: 'default' }}>
                <span className="d-flex align-items-center">
                  <i className="bi bi-calendar-event mr-2" style={{ width: '1.25rem' }} />
                  Змінити дату надходження
                </span>
                <i className="bi bi-chevron-right" style={{ fontSize: '0.75rem' }} />
              </div>
              {showArrivalSubmenu && (
                <div
                  className="dropdown-menu show position-absolute"
                  style={{ left: '100%', top: 0, marginTop: 0, marginLeft: '-1px', zIndex: 1051, minWidth: '12rem' }}
                  onMouseEnter={() => { if (arrivalSubmenuTimeoutRef.current) clearTimeout(arrivalSubmenuTimeoutRef.current); }}
                  onMouseLeave={() => setShowArrivalSubmenu(false)}
                >
                  <button type="button" className="dropdown-item d-flex align-items-center" onClick={() => { setShowArrivalSubmenu(false); onCloseDropdown(); onOpenBulkArrivalDate(); }}>
                    <i className="bi bi-calendar-event mr-2" style={{ width: '1.25rem' }} />
                    Встановити дату надходження
                  </button>
                  <button
                    type="button"
                    className="dropdown-item d-flex align-items-center"
                    onClick={() => { setShowArrivalSubmenu(false); onCloseDropdown(); onOpenBulkClearArrivalDate(); }}
                    disabled={bulkClearLoading}
                  >
                    <i className="bi bi-calendar-x mr-2" style={{ width: '1.25rem' }} />
                    Очистити дату надходження
                  </button>
                </div>
              )}
            </div>
            <div
              className="position-relative"
              onMouseEnter={() => {
                if (categorySubmenuTimeoutRef.current) clearTimeout(categorySubmenuTimeoutRef.current);
                setShowCategorySubmenu(true);
              }}
              onMouseLeave={() => {
                categorySubmenuTimeoutRef.current = setTimeout(() => setShowCategorySubmenu(false), 150);
              }}
            >
              <div className="dropdown-item d-flex align-items-center justify-content-between" style={{ cursor: 'default' }}>
                <span className="d-flex align-items-center">
                  <i className="bi bi-folder2 mr-2" style={{ width: '1.25rem' }} />
                  Змінити категорії
                </span>
                <i className="bi bi-chevron-right" style={{ fontSize: '0.75rem' }} />
              </div>
              {showCategorySubmenu && (
                <div
                  className="dropdown-menu show position-absolute"
                  style={{ left: '100%', top: 0, marginTop: 0, marginLeft: '-1px', zIndex: 1051, minWidth: '12rem' }}
                  onMouseEnter={() => { if (categorySubmenuTimeoutRef.current) clearTimeout(categorySubmenuTimeoutRef.current); }}
                  onMouseLeave={() => setShowCategorySubmenu(false)}
                >
                  <button type="button" className="dropdown-item d-flex align-items-center" onClick={() => { setShowCategorySubmenu(false); onCloseDropdown(); onOpenBulkAddCategory(); }}>
                    <i className="bi bi-folder-plus mr-2" style={{ width: '1.25rem' }} />
                    Додати категорії
                  </button>
                  <button type="button" className="dropdown-item d-flex align-items-center" onClick={() => { setShowCategorySubmenu(false); onCloseDropdown(); onOpenBulkRemoveCategory(); }}>
                    <i className="bi bi-folder-minus mr-2" style={{ width: '1.25rem' }} />
                    Видалити категорії
                  </button>
                </div>
              )}
            </div>
            <button type="button" className="dropdown-item d-flex align-items-center" onClick={onOpenBulkDiscount}>
              <i className="bi bi-percent mr-2" style={{ width: '1.25rem' }} />
              Встановити знижку для всіх
            </button>
            <button type="button" className="dropdown-item d-flex align-items-center" onClick={() => { onCloseDropdown(); onOpenBulkDiscountCategory(); }}>
              <i className="bi bi-tag mr-2" style={{ width: '1.25rem' }} />
              Встановити категорію знижки
            </button>
            <button type="button" className="dropdown-item d-flex align-items-center" onClick={() => { onCloseDropdown(); onOpenBulkStatus(); }}>
              <i className="bi bi-toggle-on mr-2" style={{ width: '1.25rem' }} />
              Змінити статус
            </button>
            <div className="dropdown-divider" />
            <button type="button" className="dropdown-item d-flex align-items-center" onClick={onClearSelection}>
              <i className="bi bi-x-circle mr-2" style={{ width: '1.25rem' }} />
              Зняти вибір
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default SelectedProductsDropdown;
